// extracted by mini-css-extract-plugin
module.exports = {"container":"from_container__1YpP3","text_order":"from_text_order__19Fnu","check":"from_check__8h5ph"};